import request from '@/utils/request'

export function getScoreSection(local_type_id, score, area) {
    return request({
        url: '/web/gk_tools/getScoreSection',
        method: 'post',
        data: {
            local_type_id: local_type_id,
            score: score,
            area: area
        }
    })
}
export function getNewScoreSection(local_type_id, score, area) {
    return request({
        url: '/school/gk_tools/getSpecialScoreSection',
        method: 'post',
        data: {
            local_type_id: local_type_id,
            score: score,
            area: area
        }
    })
}
export function getScoreLine(area) {
    return request({
        url: '/web/gk_tools/getWebScoreLine',
        method: 'post',
        data: {
            area: area
        }
    })
}
export function getPercentByScore(area,score,scl_name,local_type_id,local_batch_type) {
    return request({
        url: '/web/gk_tools/getPercentByScore',
        method: 'post',
        data: {
            local_type_id: local_type_id,
            area: area,
            score: score,
            scl_name: scl_name,
            local_batch_type: local_batch_type,
            year: ''
        }
    })
}
export function getSpecial(data,page) {
    return request({
        url: '/web/school_plan_score/getSpecial',
        method: 'post',
        data: {
            local_type_id: data.local_type_id,
            area: data.area,
            score: data.score,
            rank: data.rank,
            year: data.year,
            page: page
        }
    })
}
export function getAdmissionList(local_type_id, score, local_batch_type, area, page) {
    return request({
        url: '/web/gk_tools/getSchoolByScore',
        method: 'post',
        data: {
            local_type_id: local_type_id,
            local_batch_type: local_batch_type,
            area: area,
            score: score,
            page: page
        }
    })
}